// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppResourceTypeView } from "../../app/v1/app_resource";
import { AppUserDomain } from "../../app/v1/app_user";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { UserStatus as UserStatus$ } from "../../user/v1/user";
import { AppResource } from "../../app/v1/app_resource";
import { User } from "../../user/v1/user";
import { PolicyRef } from "../../policy/v1/policy";
import { SortOptions } from "../../search/v1/sort";
import { SlackChannel } from "./accessreview_communication";
import { Duration } from "../../../../google/protobuf/duration";
import { AppUser } from "../../app/v1/app_user";
import { App } from "../../app/v1/app";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlement } from "../../app/v1/app_entitlement";
import { ActorObjectPermissions } from "../../iam/v1/authorization";
import { CloseDecision } from "./accessreview_actions";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.accessreview.v1.SingleAppSetup
 */
export interface SingleAppSetup {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MultiAppEntitlement
 */
export interface MultiAppEntitlement {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string entitlement_ids = 2;
     */
    entitlementIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.EntitlementToDetails
 */
export interface EntitlementToDetails {
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.CampaignEntitlementDetails> entitlement_details = 1;
     */
    entitlementDetails: {
        [key: string]: CampaignEntitlementDetails;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.CampaignEntitlementDetails
 */
export interface CampaignEntitlementDetails {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string policy_id = 3;
     */
    policyId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MultiAppSetup
 */
export interface MultiAppSetup {
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.MultiAppEntitlement> app_entitlements = 1;
     */
    appEntitlements: {
        [key: string]: MultiAppEntitlement;
    };
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.EntitlementToDetails> app_entitlement_details = 2;
     */
    appEntitlementDetails: {
        [key: string]: EntitlementToDetails;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.NotificationConfig
 */
export interface NotificationConfig {
    /**
     * @generated from protobuf field: bool send_reminders = 1;
     */
    sendReminders: boolean;
    /**
     * @generated from protobuf field: bool send_close = 2;
     */
    sendClose: boolean;
    /**
     * @generated from protobuf field: bool send_kickoff = 3;
     */
    sendKickoff: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReview
 */
export interface AccessReview {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string created_by_id = 3;
     */
    createdById: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewState state = 4;
     */
    state: AccessReviewState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string description = 7;
     */
    description: string;
    /**
     * @generated from protobuf field: string policy_id = 8;
     */
    policyId: string;
    /**
     * @generated from protobuf field: bool auto_resolve = 9;
     */
    autoResolve: boolean;
    /**
     * target completion date
     *
     * @generated from protobuf field: google.protobuf.Timestamp completion_date = 10;
     */
    completionDate?: Timestamp;
    /**
     * when campaign was actually closed
     *
     * @generated from protobuf field: google.protobuf.Timestamp closed_at = 11;
     */
    closedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 12;
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 13;
     */
    startedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: setup_metadata
     */
    setupMetadata: {
        oneofKind: "singleApp";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SingleAppSetup single_app = 100;
         */
        singleApp: SingleAppSetup;
    } | {
        oneofKind: "multiApp";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.MultiAppSetup multi_app = 101;
         */
        multiApp: MultiAppSetup;
    } | {
        oneofKind: "bindings";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.BindingObjectSetup bindings = 102;
         */
        bindings: BindingObjectSetup;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExclusionScope exclusion_scope = 14;
     */
    exclusionScope?: AccessReviewExclusionScope;
    /**
     * AccessReviewScope: This is the previously used exclusion scope used to explicitly filter out
     * access review selections based on selected criteria. The exclusion criteria were
     * inverted on save to specify criteria required to create a selection. Even so it wasn't
     * feasible to migrate this property over to the new system.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScope scope = 15;
     */
    scope?: AccessReviewScope;
    /**
     * AccessReviewInclusionScope: This is the new scope used to exclusively include selections
     * based on selected criteria. Using a new object enabled us to avoid complicated logic
     * merging divergent behaviors while having a feature flag in place and previously
     * configured campaigns using the old way.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope = 16;
     */
    inclusionScope?: AccessReviewInclusionScope;
    /**
     * @generated from protobuf field: int32 expected_ticket_count = 17;
     */
    expectedTicketCount: number;
    /**
     * The ID of the template if the campaign was created from one
     *
     * @generated from protobuf field: string access_review_template_id = 18;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int64 scoping_version = 19;
     */
    scopingVersion: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 20;
     */
    scopeV2?: AccessReviewScopeV2;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp connector_sources_frozen_at = 21;
     */
    connectorSourcesFrozenAt?: Timestamp;
    /**
     * @generated from protobuf field: bool has_accuracy_support = 22;
     */
    hasAccuracySupport: boolean;
    /**
     * @generated from protobuf field: string review_instructions = 23;
     */
    reviewInstructions: string;
    /**
     * Determines the policy applied to the campaign. Default is false, using the campaign policy.
     * If true, the order of precedence is entitlement → app → campaign policy.
     *
     * @generated from protobuf field: bool use_policy_override = 24;
     */
    usePolicyOverride: boolean;
    /**
     * the default view that reviewers will see when they complete their access reviews
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewViewType default_view = 25;
     */
    defaultView: AccessReviewViewType;
    /**
     * @generated from protobuf field: bool auto_generate_report = 26;
     */
    autoGenerateReport: boolean;
    /**
     * this sets the scope type for the access review
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 27;
     */
    scopeType: AccessReviewScopeType;
    /**
     * this setting is used for access conflict type scope
     *
     * @generated from protobuf field: bool exempt_certified_access_conflicts = 28;
     */
    exemptCertifiedAccessConflicts: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSignatureConfig signature_config = 29;
     */
    signatureConfig?: ReviewSignatureConfig;
    /**
     * Auto-start configuration
     *
     * @generated from protobuf field: bool auto_start_campaign = 30;
     */
    autoStartCampaign: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp scheduled_start_date = 31;
     */
    scheduledStartDate?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action = 32;
     */
    accuracyIssueAction: AccuracyIssueAction;
    /**
     * Auto-close configuration
     * completion_date is used as the scheduled close date
     *
     * @generated from protobuf field: bool auto_close_campaign = 33;
     */
    autoCloseCampaign: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.CloseDecision auto_close_decision = 34;
     */
    autoCloseDecision: CloseDecision;
}
/**
 * Signature configuration for access review submissions
 *
 * @generated from protobuf message c1.api.accessreview.v1.ReviewSignatureConfig
 */
export interface ReviewSignatureConfig {
    /**
     * @generated from protobuf field: bool require_signature = 1;
     */
    requireSignature: boolean;
    /**
     * @generated from protobuf field: string step_up_provider_id = 2;
     */
    stepUpProviderId: string;
    /**
     * @generated from protobuf field: string meaning_of_signature = 3;
     */
    meaningOfSignature: string;
    /**
     * @generated from protobuf field: string tsp_url = 4;
     */
    tspUrl: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.BindingObjectSetup
 */
export interface BindingObjectSetup {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewScope
 */
export interface AccessReviewScope {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType app_user_types = 1;
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2;
     */
    appUserStatuses: AppUserStatus[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewExclusionScope
 */
export interface AccessReviewExclusionScope {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType app_user_types = 1;
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2;
     */
    appUserStatuses: AppUserStatus[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.IncludedUserAttributeValue
 */
export interface IncludedUserAttributeValue {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.IncludedUserAttributeValues
 */
export interface IncludedUserAttributeValues {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.IncludedUserAttributeValue values = 1;
     */
    values: IncludedUserAttributeValue[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewInclusionScope
 */
export interface AccessReviewInclusionScope {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType app_user_types = 1;
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2;
     */
    appUserStatuses: AppUserStatus[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.UserStatus user_statuses = 3;
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes = 4;
     */
    multiUserProfileAttributes: {
        [key: string]: IncludedUserAttributeValues;
    };
    /**
     * @generated from protobuf field: repeated string user_ids = 5;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: repeated string manager_ids = 6;
     */
    managerIds: string[];
    /**
     * @generated from protobuf field: bool no_account_owners = 7;
     */
    noAccountOwners: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewExpandMask
 */
export interface AccessReviewExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask
 */
export interface AccessReviewAppEntitlementExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask
 */
export interface AccessReviewTemplateAppEntitlementExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewView
 */
export interface AccessReviewView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReview access_review = 1;
     */
    accessReview?: AccessReview;
    /**
     * @generated from protobuf field: string created_by_user_path = 2;
     */
    createdByUserPath: string;
    /**
     * @generated from protobuf field: string policy_path = 4;
     */
    policyPath: string;
    /**
     * @generated from protobuf field: c1.api.iam.v1.ActorObjectPermissions object_permissions = 5;
     */
    objectPermissions?: ActorObjectPermissions;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppRequest
 */
export interface AccessReviewServiceListEntitlementsWithMultiAppRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewAppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementView
 */
export interface AccessReviewAppEntitlementView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1;
     */
    appEntitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string policy_path = 3;
     */
    policyPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4;
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_resource_path = 5;
     */
    appResourcePath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppResponse
 */
export interface AccessReviewServiceListEntitlementsWithMultiAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list = 1;
     */
    list: AccessReviewAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceGetResponse
 */
export interface AccessReviewServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewView access_review = 1;
     */
    accessReview?: AccessReviewView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateResponse
 */
export interface AccessReviewServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewView access_review = 1;
     */
    accessReview?: AccessReviewView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateResponse
 */
export interface AccessReviewServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewView access_review = 1;
     */
    accessReview?: AccessReviewView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetAccessReviewSelectionRequest
 */
export interface GetAccessReviewSelectionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string selection_id = 2;
     */
    selectionId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionExpandMask
 */
export interface AccessReviewSelectionExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlement
 */
export interface AccessReviewEntitlement {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string access_review_id = 2;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 4;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string policy_id = 5;
     */
    policyId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementView
 */
export interface AccessReviewEntitlementView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlement access_review_entitlement = 1;
     */
    accessReviewEntitlement?: AccessReviewEntitlement;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3;
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string policy_path = 4;
     */
    policyPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionRef
 */
export interface AccessReviewSelectionRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceRef
 */
export interface AccessReviewConnectorSourceRef {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelection
 */
export interface AccessReviewSelection {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string access_review_id = 2;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
    /**
     * @generated from protobuf field: string app_id = 5;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string entitlement_ids = 6;
     */
    entitlementIds: string[];
    /**
     * @generated from protobuf field: string certify_task_id = 7;
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: string revoke_task_id = 8;
     */
    revokeTaskId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelectionState state = 9;
     */
    state: AccessReviewSelectionState;
    /**
     * @generated from protobuf field: string policy_id = 10;
     */
    policyId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 11;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 12;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 13;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionView
 */
export interface AccessReviewSelectionView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelection access_review_selection = 1;
     */
    accessReviewSelection?: AccessReviewSelection;
    /**
     * @generated from protobuf field: string app_user_path = 2;
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string user_path = 3;
     */
    userPath: string;
    /**
     * @generated from protobuf field: string entitlements_path = 4;
     */
    entitlementsPath: string;
    /**
     * @generated from protobuf field: string cert_task_path = 5;
     */
    certTaskPath: string;
    /**
     * @generated from protobuf field: string app_path = 6;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string policy_path = 7;
     */
    policyPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceGetRequest
 */
export interface AccessReviewServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 2;
     */
    expandMask?: AccessReviewExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateRequest
 */
export interface AccessReviewServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReview access_review = 1;
     */
    accessReview?: AccessReview;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 3;
     */
    expandMask?: AccessReviewExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateRequest
 */
export interface AccessReviewServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completion_date = 3;
     */
    completionDate?: Timestamp;
    /**
     * @generated from protobuf field: string policy_id = 4;
     */
    policyId: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 5;
     */
    ownerIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 6;
     */
    expandMask?: AccessReviewExpandMask;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 7;
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: string duplicate_from = 8;
     */
    duplicateFrom: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 9;
     */
    scopeType: AccessReviewScopeType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteRequest
 */
export interface AccessReviewServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteResponse
 */
export interface AccessReviewServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListRequest
 */
export interface AccessReviewServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 3;
     */
    expandMask?: AccessReviewExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListResponse
 */
export interface AccessReviewServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewView list = 1;
     */
    list: AccessReviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReportRef
 */
export interface AccessReviewReportRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReport
 */
export interface AccessReviewReport {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string access_review_id = 2;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string download_url = 3;
     */
    downloadUrl: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReportState state = 4;
     */
    state: ReportState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: map<int32, string> hashes = 6;
     */
    hashes: {
        [key: number]: string;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListRequest
 */
export interface AccessReviewReportServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewReportRef refs = 6;
     */
    refs: AccessReviewReportRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListResponse
 */
export interface AccessReviewReportServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewReport list = 1;
     */
    list: AccessReviewReport[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedRequest
 */
export interface AccessReviewConnectorSourceServiceListOutdatedRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedResponse
 */
export interface AccessReviewConnectorSourceServiceListOutdatedResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1;
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp
 */
export interface AccessReviewEntitlementRollupByApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 2;
     */
    list: AccessReviewEntitlementRollup[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByAppUser
 */
export interface AccessReviewEntitlementRollupByAppUser {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 2;
     */
    list: AccessReviewEntitlementRollup[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollup
 */
export interface AccessReviewEntitlementRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1;
     */
    appEntitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: int32 assigned_tasks = 2;
     */
    assignedTasks: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3;
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4;
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_resource_path = 5;
     */
    appResourcePath: string;
    /**
     * @generated from protobuf field: string app_path = 6;
     */
    appPath: string;
    /**
     * @generated from protobuf field: int64 pending_submission_count = 7;
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask
 */
export interface AccessReviewEntitlementRollupExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask
 */
export interface AccessReviewEntitlementPreviewExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchRequest
 */
export interface AccessReviewEntitlementPreviewServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask expand_mask = 7;
     */
    expandMask?: AccessReviewEntitlementPreviewExpandMask;
    /**
     * @generated from protobuf field: string access_review_id = 8;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreview
 */
export interface AccessReviewEntitlementPreview {
    /**
     * @generated from protobuf field: string app_user_id = 1;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp entitlement_expiration_time = 5;
     */
    entitlementExpirationTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp entitlement_discovered_time = 6;
     */
    entitlementDiscoveredTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewView
 */
export interface AccessReviewEntitlementPreviewView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementPreview scope = 1;
     */
    scope?: AccessReviewEntitlementPreview;
    /**
     * @generated from protobuf field: string app_user_path = 2;
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3;
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_entitlement_user_binding = 5;
     */
    appEntitlementUserBinding: string;
    /**
     * @generated from protobuf field: string user_path = 6;
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchResponse
 */
export interface AccessReviewEntitlementPreviewServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementPreviewView list = 1;
     */
    list: AccessReviewEntitlementPreviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewRef
 */
export interface AccessReviewRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplate
 */
export interface AccessReviewTemplate {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string policy_id = 2;
     */
    policyId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Duration access_review_duration = 6;
     */
    accessReviewDuration?: Duration;
    /**
     * @generated from protobuf field: string description = 7;
     */
    description: string;
    /**
     * @generated from protobuf field: string display_name = 8;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope = 9;
     */
    inclusionScope?: AccessReviewInclusionScope;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.RecurrenceRule recurrence_rule = 10;
     */
    recurrenceRule?: RecurrenceRule;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp next_scheduled_campaign_at = 11;
     */
    nextScheduledCampaignAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 12;
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: bool is_campaign_schedule_enabled = 13;
     */
    isCampaignScheduleEnabled: boolean;
    /**
     * @generated from protobuf oneof: slack_channel_details
     */
    slackChannelDetails: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannel slack_channel = 100;
         */
        slackChannel: SlackChannel;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: int32 occurrences = 14;
     */
    occurrences: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope = 15;
     */
    scope?: AccessReviewScopeV2;
    /**
     * @generated from protobuf field: string review_instructions = 16;
     */
    reviewInstructions: string;
    /**
     * @generated from protobuf field: bool use_policy_override = 17;
     */
    usePolicyOverride: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewViewType default_view = 18;
     */
    defaultView: AccessReviewViewType;
    /**
     * auto generate report when campaign is closed
     *
     * @generated from protobuf field: bool auto_generate_report = 19;
     */
    autoGenerateReport: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 20;
     */
    scopeType: AccessReviewScopeType;
    /**
     * @generated from protobuf field: bool exempt_certified_access_conflicts = 21;
     */
    exemptCertifiedAccessConflicts: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSignatureConfig signature_config = 22;
     */
    signatureConfig?: ReviewSignatureConfig;
    /**
     * Auto-start configuration
     * next_scheduled_campaign_at will be used as the scheduled start date
     *
     * @generated from protobuf field: bool auto_start_campaign = 23;
     */
    autoStartCampaign: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action = 24;
     */
    accuracyIssueAction: AccuracyIssueAction;
    /**
     * Auto-close configuration
     * start date and access_review_duration will be used to calculate the scheduled close date
     *
     * @generated from protobuf field: bool auto_close_campaign = 25;
     */
    autoCloseCampaign: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.CloseDecision auto_close_decision = 26;
     */
    autoCloseDecision: CloseDecision;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.RecurrenceRule
 */
export interface RecurrenceRule {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.RecurrenceRule.Frequency frequency = 1;
     */
    frequency: RecurrenceRule_Frequency; // Frequency of the recurrence (daily, weekly, etc.)
    /**
     * @generated from protobuf field: int32 interval = 2;
     */
    interval: number; // Number of time units between occurrences
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 3;
     */
    startDate?: Timestamp; // Start date of the recurrence in ISO 8601 format (e.g., "2024-01-01")
    /**
     * @generated from protobuf oneof: end_condition
     */
    endCondition: {
        oneofKind: "endDate";
        /**
         * @generated from protobuf field: google.protobuf.Timestamp end_date = 4;
         */
        endDate: Timestamp; // End date of the recurrence in ISO 8601 format (e.g., "2025-01-01")
    } | {
        oneofKind: "occurrences";
        /**
         * @generated from protobuf field: int32 occurrences = 5;
         */
        occurrences: number; // Total number of occurrences
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.RecurrenceRule.Frequency
 */
export enum RecurrenceRule_Frequency {
    /**
     * @generated from protobuf enum value: FREQUENCY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FREQUENCY_NONE = 1;
     */
    NONE = 1,
    /**
     * @generated from protobuf enum value: FREQUENCY_DAILY = 2;
     */
    DAILY = 2,
    /**
     * @generated from protobuf enum value: FREQUENCY_WEEKLY = 3;
     */
    WEEKLY = 3,
    /**
     * @generated from protobuf enum value: FREQUENCY_MONTHLY = 4;
     */
    MONTHLY = 4,
    /**
     * @generated from protobuf enum value: FREQUENCY_YEARLY = 5;
     */
    YEARLY = 5
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateRequest
 */
export interface AccessReviewTemplateServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Duration access_review_duration = 3;
     */
    accessReviewDuration?: Duration;
    /**
     * @generated from protobuf field: string policy_id = 4;
     */
    policyId: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 5;
     */
    ownerIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 6;
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 7;
     */
    scopeType: AccessReviewScopeType;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateResponse
 */
export interface AccessReviewTemplateServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1;
     */
    accessReviewTemplate?: AccessReviewTemplate;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteRequest
 */
export interface AccessReviewTemplateServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteResponse
 */
export interface AccessReviewTemplateServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListRequest
 */
export interface AccessReviewTemplateServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListResponse
 */
export interface AccessReviewTemplateServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplate list = 1;
     */
    list: AccessReviewTemplate[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchRequest
 */
export interface AccessReviewTemplateServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.SortOptions sort_options = 4;
     */
    sortOptions?: SortOptions;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateRef refs = 5;
     */
    refs: AccessReviewTemplateRef[];
    /**
     * Search for access review templates that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 6;
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchResponse
 */
export interface AccessReviewTemplateServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplate list = 1;
     */
    list: AccessReviewTemplate[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetRequest
 */
export interface AccessReviewTemplateServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetResponse
 */
export interface AccessReviewTemplateServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1;
     */
    accessReviewTemplate?: AccessReviewTemplate;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersRequest
 */
export interface AccessReviewTemplateServiceListOwnersRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersResponse
 */
export interface AccessReviewTemplateServiceListOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersRequest
 */
export interface AccessReviewTemplateServiceSearchOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateOwnerRef refs = 4;
     */
    refs: AccessReviewTemplateOwnerRef[];
    /**
     * @generated from protobuf field: repeated string user_ids = 5;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView
 */
export interface AccessReviewTemplateServiceSearchOwnerView {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
    /**
     * @generated from protobuf field: string access_review_template_id = 2;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersResponse
 */
export interface AccessReviewTemplateServiceSearchOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView list = 1;
     */
    list: AccessReviewTemplateServiceSearchOwnerView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateRequest
 */
export interface AccessReviewTemplateServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1;
     */
    accessReviewTemplate?: AccessReviewTemplate;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateResponse
 */
export interface AccessReviewTemplateServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1;
     */
    accessReviewTemplate?: AccessReviewTemplate;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersRequest
 */
export interface AccessReviewTemplateServiceSetOwnersRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 2;
     */
    ownerIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersResponse
 */
export interface AccessReviewTemplateServiceSetOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsRequest
 */
export interface AccessReviewTemplateServiceListAccessReviewsRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsResponse
 */
export interface AccessReviewTemplateServiceListAccessReviewsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewView list = 1;
     */
    list: AccessReviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateRef
 */
export interface AccessReviewTemplateRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateOwnerRef
 */
export interface AccessReviewTemplateOwnerRef {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 2;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest
 */
export interface AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse
 */
export interface AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem
 */
export interface AccessReviewTemplateAppResourceRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource item = 1;
     */
    item?: AppResource;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView entitlements = 2;
     */
    entitlements: AccessReviewTemplateAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView
 */
export interface AccessReviewTemplateAppEntitlementView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1;
     */
    appEntitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string policy_path = 3;
     */
    policyPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4;
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_resource_path = 5;
     */
    appResourcePath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewScopeV2
 */
export interface AccessReviewScopeV2 {
    /**
     * @generated from protobuf oneof: apps_and_resources_scope
     */
    appsAndResourcesScope: {
        oneofKind: "appAccess";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.ApplicationAccessScope app_access = 100;
         */
        appAccess: ApplicationAccessScope;
    } | {
        oneofKind: "specificResources";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SpecificResourcesScope specific_resources = 101;
         */
        specificResources: SpecificResourcesScope;
    } | {
        oneofKind: "appSelectionCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AppSelectionCriteriaScope app_selection_criteria = 102;
         */
        appSelectionCriteria: AppSelectionCriteriaScope;
    } | {
        oneofKind: "resourceTypeSelections";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.ResourceTypeSelectionScope resource_type_selections = 103;
         */
        resourceTypeSelections: ResourceTypeSelectionScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: users_scope
     */
    usersScope: {
        oneofKind: "allUsers";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllUsersScope all_users = 200;
         */
        allUsers: AllUsersScope;
    } | {
        oneofKind: "selectedUsers";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SelectedUsersScope selected_users = 201;
         */
        selectedUsers: SelectedUsersScope;
    } | {
        oneofKind: "userCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.UserCriteriaScope user_criteria = 202;
         */
        userCriteria: UserCriteriaScope;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.CelExpressionScope cel_expression = 203;
         */
        celExpression: CelExpressionScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: accounts_scope
     */
    accountsScope: {
        oneofKind: "allAccounts";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllAccountsScope all_accounts = 300;
         */
        allAccounts: AllAccountsScope;
    } | {
        oneofKind: "accountCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccountCriteriaScope account_criteria = 301;
         */
        accountCriteria: AccountCriteriaScope;
    } | {
        oneofKind: "accountCelExpression";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.CelExpressionScope account_cel_expression = 302;
         */
        accountCelExpression: CelExpressionScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: grants_scope
     */
    grantsScope: {
        oneofKind: "allGrants";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllGrantsScope all_grants = 400;
         */
        allGrants: AllGrantsScope;
    } | {
        oneofKind: "grantsByCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.GrantsByCriteriaScope grants_by_criteria = 401;
         */
        grantsByCriteria: GrantsByCriteriaScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: access_conflicts_scope
     */
    accessConflictsScope: {
        oneofKind: "allAccessConflicts";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllAccessConflictsScope all_access_conflicts = 500;
         */
        allAccessConflicts: AllAccessConflictsScope;
    } | {
        oneofKind: "specificAccessConflicts";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SpecificAccessConflictsScope specific_access_conflicts = 501;
         */
        specificAccessConflicts: SpecificAccessConflictsScope;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllAccessConflictsScope
 */
export interface AllAccessConflictsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SpecificAccessConflictsScope
 */
export interface SpecificAccessConflictsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ApplicationAccessScope
 */
export interface ApplicationAccessScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SpecificResourcesScope
 */
export interface SpecificResourcesScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppSelectionCriteriaScope
 */
export interface AppSelectionCriteriaScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ResourceTypeSelectionScope
 */
export interface ResourceTypeSelectionScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllUsersScope
 */
export interface AllUsersScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SelectedUsersScope
 */
export interface SelectedUsersScope {
    /**
     * @generated from protobuf field: repeated string user_ids = 1;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UserCriteriaScope
 */
export interface UserCriteriaScope {
    /**
     * @generated from protobuf field: repeated string manager_user_ids = 1;
     */
    managerUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_status = 2;
     */
    userStatus: UserStatus$[];
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes = 3;
     */
    multiUserProfileAttributes: {
        [key: string]: IncludedUserAttributeValues;
    };
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef group_app_entitlements_ref = 4;
     */
    groupAppEntitlementsRef: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.CelExpressionScope
 */
export interface CelExpressionScope {
    /**
     * @generated from protobuf field: string expression = 1;
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllAccountsScope
 */
export interface AllAccountsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccountCriteriaScope
 */
export interface AccountCriteriaScope {
    /**
     * @generated from protobuf field: bool no_account_owner = 1;
     */
    noAccountOwner: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2;
     */
    appUserStatuses: AppUserStatus[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType account_types = 3;
     */
    accountTypes: AppUserType[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserDomain account_domain = 4;
     */
    accountDomain: AppUserDomain;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllGrantsScope
 */
export interface AllGrantsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GrantsByCriteriaScope
 */
export interface GrantsByCriteriaScope {
    /**
     * @generated from protobuf oneof: criteria_filter
     */
    criteriaFilter: {
        oneofKind: "daysSinceAdded";
        /**
         * @generated from protobuf field: google.protobuf.Duration days_since_added = 100;
         */
        daysSinceAdded: Duration;
    } | {
        oneofKind: "daysSinceReviewed";
        /**
         * @generated from protobuf field: google.protobuf.Duration days_since_reviewed = 101;
         */
        daysSinceReviewed: Duration;
    } | {
        oneofKind: "grantsAddedBetween";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.GrantsAddedBetween grants_added_between = 103;
         */
        grantsAddedBetween: GrantsAddedBetween;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.GrantFilterType type_filter = 1;
     */
    typeFilter: GrantFilterType;
    /**
     * @generated from protobuf field: google.protobuf.Duration days_since_last_used = 2;
     */
    daysSinceLastUsed?: Duration;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.GrantSourceFilter source_filter = 3;
     */
    sourceFilter: GrantSourceFilter;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.GrantAccessProfileFilter access_profile_filter = 4;
     */
    accessProfileFilter?: GrantAccessProfileFilter;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GrantsAddedBetween
 */
export interface GrantsAddedBetween {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 1;
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 2;
     */
    endDate?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GrantAccessProfileFilter
 */
export interface GrantAccessProfileFilter {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessProfileFilterType filter_type = 1;
     */
    filterType: AccessProfileFilterType;
    /**
     * Access profile IDs to EXCLUDE from the campaign
     * Used when filter_type = EXCLUDE_SPECIFIC
     * Max 32 profile IDs
     *
     * @generated from protobuf field: repeated string excluded_access_profile_ids = 2;
     */
    excludedAccessProfileIds: string[];
    /**
     * Access profile IDs to INCLUDE in the campaign
     * Used when filter_type = INCLUDE_SPECIFIC
     * Max 32 profile IDs
     *
     * @generated from protobuf field: repeated string included_access_profile_ids = 3;
     */
    includedAccessProfileIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSource
 */
export interface AccessReviewConnectorSource {
    /**
     * @generated from protobuf field: string tenant_id = 1;
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string access_review_id = 4;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_start_at = 8;
     */
    syncStartAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_end_at = 9;
     */
    syncEndAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 connector_version = 10;
     */
    connectorVersion: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ConnectorType connector_type = 11;
     */
    connectorType: ConnectorType;
    /**
     * contains the id of the sync artifact
     *
     * @generated from protobuf field: string connector_sync_artifact = 12;
     */
    connectorSyncArtifact: string;
    /**
     * @generated from protobuf field: map<string, int64> stats = 13;
     */
    stats: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp frozen_at = 14;
     */
    frozenAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceView
 */
export interface AccessReviewConnectorSourceView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSource access_review_connector_source = 1;
     */
    accessReviewConnectorSource?: AccessReviewConnectorSource;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string connector_path = 3;
     */
    connectorPath: string;
    /**
     * @generated from protobuf field: string sync_lifecycle_path = 4;
     */
    syncLifecyclePath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask
 */
export interface AccessReviewConnectorSourceExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef
 */
export interface AccessReviewTemplateResourceRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 2;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchRequest
 */
export interface AccessReviewTemplateResourceRollupSearchRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewTemplateAppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string query = 5;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef refs = 6;
     */
    refs: AccessReviewTemplateResourceRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchResponse
 */
export interface AccessReviewTemplateResourceRollupSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem list = 1;
     */
    list: AccessReviewTemplateAppResourceRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem
 */
export interface AccessReviewTemplateResourceTypeRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeView item = 1;
     */
    item?: AppResourceTypeView;
    /**
     * @generated from protobuf field: int64 resource_count = 2;
     */
    resourceCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef
 */
export interface AccessReviewTemplateResourceTypeRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchRequest
 */
export interface AccessReviewTemplateSearchResourceTypeRollupSearchRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef refs = 5;
     */
    refs: AccessReviewTemplateResourceTypeRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchResponse
 */
export interface AccessReviewTemplateSearchResourceTypeRollupSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem list = 1;
     */
    list: AccessReviewTemplateResourceTypeRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3;
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ValidateScopeRequest
 */
export interface ValidateScopeRequest {
    /**
     * @generated from protobuf field: string campaign_id = 1;
     */
    campaignId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ValidateScopeRequest.CampaignType campaign_type = 2;
     */
    campaignType: ValidateScopeRequest_CampaignType;
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ValidateScopeRequest.CampaignType
 */
export enum ValidateScopeRequest_CampaignType {
    /**
     * @generated from protobuf enum value: CAMPAIGN_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAMPAIGN_TYPE_ACCESS_REVIEW = 1;
     */
    ACCESS_REVIEW = 1,
    /**
     * @generated from protobuf enum value: CAMPAIGN_TYPE_ACCESS_REVIEW_TEMPLATE = 2;
     */
    ACCESS_REVIEW_TEMPLATE = 2
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListRequest
 */
export interface AccessReviewConnectorSourceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 3;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListResponse
 */
export interface AccessReviewConnectorSourceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1;
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchRequest
 */
export interface AccessReviewConnectorSourceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 4;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 5;
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs = 6;
     */
    refs: AccessReviewConnectorSourceRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchResponse
 */
export interface AccessReviewConnectorSourceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1;
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchRequest
 */
export interface AccessReviewConnectorSourceOutdatedSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 4;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 5;
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs = 6;
     */
    refs: AccessReviewConnectorSourceRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchResponse
 */
export interface AccessReviewConnectorSourceOutdatedSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1;
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * -------- Access Review By Access Conflicts
 *
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask
 */
export interface AccessReviewSetupAccessConflictExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictView
 */
export interface AccessReviewSetupAccessConflictView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSetupAccessConflict access_conflict = 1;
     */
    accessConflict?: AccessReviewSetupAccessConflict;
    /**
     * @generated from protobuf field: string access_conflict_path = 2;
     */
    accessConflictPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflict
 */
export interface AccessReviewSetupAccessConflict {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListRequest
 */
export interface AccessReviewByAccessConflictsServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewSetupAccessConflictExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListResponse
 */
export interface AccessReviewByAccessConflictsServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSetupAccessConflictView list = 1;
     */
    list: AccessReviewSetupAccessConflictView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictRequest
 */
export interface AccessReviewSetScopeByAccessConflictRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: repeated string access_conflict_monitor_ids = 2;
     */
    accessConflictMonitorIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 3;
     */
    scopeV2?: AccessReviewScopeV2;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictResponse
 */
export interface AccessReviewSetScopeByAccessConflictResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView
 */
export interface AccessReviewTemplateSetupAccessConflictView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict access_conflict = 1;
     */
    accessConflict?: AccessReviewTemplateSetupAccessConflict;
    /**
     * @generated from protobuf field: string access_conflict_path = 2;
     */
    accessConflictPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict
 */
export interface AccessReviewTemplateSetupAccessConflict {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2;
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListRequest
 */
export interface AccessReviewTemplateByAccessConflictsServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask = 4;
     */
    expandMask?: AccessReviewSetupAccessConflictExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListResponse
 */
export interface AccessReviewTemplateByAccessConflictsServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView list = 1;
     */
    list: AccessReviewTemplateSetupAccessConflictView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictRequest
 */
export interface AccessReviewTemplateSetScopeByAccessConflictRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1;
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated string access_conflict_monitor_ids = 2;
     */
    accessConflictMonitorIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 3;
     */
    scopeV2?: AccessReviewScopeV2;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictResponse
 */
export interface AccessReviewTemplateSetScopeByAccessConflictResponse {
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewState
 */
export enum AccessReviewState {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_OPEN = 1;
     */
    OPEN = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_CLOSED = 2;
     */
    CLOSED = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_PENDING = 3;
     */
    PENDING = 3,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_REVIEW = 4;
     */
    REVIEW = 4,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_PREPARING = 5;
     */
    PREPARING = 5,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_STARTING = 6;
     */
    STARTING = 6,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_DRAFT = 7;
     */
    DRAFT = 7,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_DELETING = 8;
     */
    DELETING = 8,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_DELETED = 9;
     */
    DELETED = 9,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_RESETTING_POLICIES = 10;
     */
    RESETTING_POLICIES = 10,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_COPYING_SETUP_ENTITLEMENTS = 11;
     */
    COPYING_SETUP_ENTITLEMENTS = 11,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_COPYING_RESOURCE_TYPE_SELECTIONS = 12;
     */
    COPYING_RESOURCE_TYPE_SELECTIONS = 12
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewViewType
 */
export enum AccessReviewViewType {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_BY_APP = 1;
     */
    BY_APP = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_BY_USER = 2;
     */
    BY_USER = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_UNSTRUCTURED = 3;
     */
    UNSTRUCTURED = 3
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewScopeType
 */
export enum AccessReviewScopeType {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SCOPE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SCOPE_TYPE_BY_ENTITLEMENTS = 1;
     */
    BY_ENTITLEMENTS = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SCOPE_TYPE_BY_ACCESS_CONFLICTS = 2;
     */
    BY_ACCESS_CONFLICTS = 2
}
/**
 * Action to take when accuracy issues are detected
 *
 * @generated from protobuf enum c1.api.accessreview.v1.AccuracyIssueAction
 */
export enum AccuracyIssueAction {
    /**
     * @generated from protobuf enum value: ACCURACY_ISSUE_ACTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Start campaign despite accuracy issues
     *
     * @generated from protobuf enum value: ACCURACY_ISSUE_ACTION_CONTINUE = 1;
     */
    CONTINUE = 1,
    /**
     * Wait until accuracy issues are resolved
     *
     * @generated from protobuf enum value: ACCURACY_ISSUE_ACTION_WAIT = 2;
     */
    WAIT = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewSelectionState
 */
export enum AccessReviewSelectionState {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CREATED = 1;
     */
    CERTIFICATION_CREATED = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_OPEN = 2;
     */
    CERTIFICATION_OPEN = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CERTIFIED = 3;
     */
    CERTIFICATION_CERTIFIED = 3,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_REJECTED = 4;
     */
    CERTIFICATION_REJECTED = 4,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_PAST_DUE = 5;
     */
    CERTIFICATION_PAST_DUE = 5,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_RESOLUTION_RESOLVED = 6;
     */
    RESOLUTION_RESOLVED = 6,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_RESOLUTION_DECLINED = 7;
     */
    RESOLUTION_DECLINED = 7,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CANCELLED = 8;
     */
    CERTIFICATION_CANCELLED = 8,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_ERROR = 9;
     */
    CERTIFICATION_ERROR = 9,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_SKIPPED = 10;
     */
    CERTIFICATION_SKIPPED = 10,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CANCELLED_BEFORE_CAMPAIGN_START = 11;
     */
    CERTIFICATION_CANCELLED_BEFORE_CAMPAIGN_START = 11
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReportState
 */
export enum ReportState {
    /**
     * @generated from protobuf enum value: REPORT_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REPORT_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: REPORT_STATE_OK = 2;
     */
    OK = 2,
    /**
     * @generated from protobuf enum value: REPORT_STATE_ERROR = 3;
     */
    ERROR = 3
}
/**
 * from c1.api.app.v1.AppUserStatus.Status
 *
 * @generated from protobuf enum c1.api.accessreview.v1.AppUserStatus
 */
export enum AppUserStatus {
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DISABLED = 2;
     */
    DISABLED = 2,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DELETED = 3;
     */
    DELETED = 3
}
/**
 * from c1.api.app.v1.AppUserType
 *
 * @generated from protobuf enum c1.api.accessreview.v1.AppUserType
 */
export enum AppUserType {
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_SERVICE_ACCOUNT = 2;
     */
    SERVICE_ACCOUNT = 2,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_SYSTEM_ACCOUNT = 3;
     */
    SYSTEM_ACCOUNT = 3
}
/**
 * from c1.api.User.v1.UserStatus
 *
 * @generated from protobuf enum c1.api.accessreview.v1.UserStatus
 */
export enum UserStatus {
    /**
     * @generated from protobuf enum value: USER_UNKNOWN = 0;
     */
    USER_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: USER_ENABLED = 1;
     */
    USER_ENABLED = 1,
    /**
     * @generated from protobuf enum value: USER_DISABLED = 2;
     */
    USER_DISABLED = 2,
    /**
     * @generated from protobuf enum value: USER_DELETED = 3;
     */
    USER_DELETED = 3
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.GrantFilterType
 */
export enum GrantFilterType {
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_PERMANENT = 1;
     */
    PERMANENT = 1,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_TEMPORARY = 2;
     */
    TEMPORARY = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.GrantSourceFilter
 */
export enum GrantSourceFilter {
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_DIRECT = 1;
     */
    DIRECT = 1,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_INHERITED = 2;
     */
    INHERITED = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessProfileFilterType
 */
export enum AccessProfileFilterType {
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_INCLUDE_ALL = 1;
     */
    INCLUDE_ALL = 1,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_EXCLUDE_ALL = 2;
     */
    EXCLUDE_ALL = 2,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_EXCLUDE_SPECIFIC = 3;
     */
    EXCLUDE_SPECIFIC = 3,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_INCLUDE_SPECIFIC = 4;
     */
    INCLUDE_SPECIFIC = 4
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ConnectorType
 */
export enum ConnectorType {
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_FILE = 1;
     */
    FILE = 1,
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_STANDARD = 2;
     */
    STANDARD = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SingleAppSetup$Type extends MessageType<SingleAppSetup> {
    constructor() {
        super("c1.api.accessreview.v1.SingleAppSetup", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SingleAppSetup
 */
export const SingleAppSetup = new SingleAppSetup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiAppEntitlement$Type extends MessageType<MultiAppEntitlement> {
    constructor() {
        super("c1.api.accessreview.v1.MultiAppEntitlement", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MultiAppEntitlement
 */
export const MultiAppEntitlement = new MultiAppEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementToDetails$Type extends MessageType<EntitlementToDetails> {
    constructor() {
        super("c1.api.accessreview.v1.EntitlementToDetails", [
            { no: 1, name: "entitlement_details", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => CampaignEntitlementDetails } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.EntitlementToDetails
 */
export const EntitlementToDetails = new EntitlementToDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CampaignEntitlementDetails$Type extends MessageType<CampaignEntitlementDetails> {
    constructor() {
        super("c1.api.accessreview.v1.CampaignEntitlementDetails", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.CampaignEntitlementDetails
 */
export const CampaignEntitlementDetails = new CampaignEntitlementDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiAppSetup$Type extends MessageType<MultiAppSetup> {
    constructor() {
        super("c1.api.accessreview.v1.MultiAppSetup", [
            { no: 1, name: "app_entitlements", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => MultiAppEntitlement } },
            { no: 2, name: "app_entitlement_details", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => EntitlementToDetails } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MultiAppSetup
 */
export const MultiAppSetup = new MultiAppSetup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationConfig$Type extends MessageType<NotificationConfig> {
    constructor() {
        super("c1.api.accessreview.v1.NotificationConfig", [
            { no: 1, name: "send_reminders", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "send_close", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "send_kickoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.NotificationConfig
 */
export const NotificationConfig = new NotificationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReview$Type extends MessageType<AccessReview> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReview", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "created_by_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewState", AccessReviewState, "ACCESS_REVIEW_STATE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 8, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 9, name: "auto_resolve", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "completion_date", kind: "message", T: () => Timestamp },
            { no: 11, name: "closed_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 13, name: "started_at", kind: "message", T: () => Timestamp },
            { no: 100, name: "single_app", kind: "message", oneof: "setupMetadata", T: () => SingleAppSetup },
            { no: 101, name: "multi_app", kind: "message", oneof: "setupMetadata", T: () => MultiAppSetup },
            { no: 102, name: "bindings", kind: "message", oneof: "setupMetadata", T: () => BindingObjectSetup },
            { no: 14, name: "exclusion_scope", kind: "message", T: () => AccessReviewExclusionScope },
            { no: 15, name: "scope", kind: "message", T: () => AccessReviewScope },
            { no: 16, name: "inclusion_scope", kind: "message", T: () => AccessReviewInclusionScope },
            { no: 17, name: "expected_ticket_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 19, name: "scoping_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 20, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 },
            { no: 21, name: "connector_sources_frozen_at", kind: "message", T: () => Timestamp },
            { no: 22, name: "has_accuracy_support", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "review_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 24, name: "use_policy_override", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "default_view", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewViewType", AccessReviewViewType, "ACCESS_REVIEW_VIEW_TYPE_"] },
            { no: 26, name: "auto_generate_report", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] },
            { no: 28, name: "exempt_certified_access_conflicts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "signature_config", kind: "message", T: () => ReviewSignatureConfig },
            { no: 30, name: "auto_start_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "scheduled_start_date", kind: "message", T: () => Timestamp },
            { no: 32, name: "accuracy_issue_action", kind: "enum", T: () => ["c1.api.accessreview.v1.AccuracyIssueAction", AccuracyIssueAction, "ACCURACY_ISSUE_ACTION_"] },
            { no: 33, name: "auto_close_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 34, name: "auto_close_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.CloseDecision", CloseDecision, "CLOSE_DECISION_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access Review" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReview
 */
export const AccessReview = new AccessReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewSignatureConfig$Type extends MessageType<ReviewSignatureConfig> {
    constructor() {
        super("c1.api.accessreview.v1.ReviewSignatureConfig", [
            { no: 1, name: "require_signature", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "step_up_provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "meaning_of_signature", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "tsp_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ReviewSignatureConfig
 */
export const ReviewSignatureConfig = new ReviewSignatureConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindingObjectSetup$Type extends MessageType<BindingObjectSetup> {
    constructor() {
        super("c1.api.accessreview.v1.BindingObjectSetup", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.BindingObjectSetup
 */
export const BindingObjectSetup = new BindingObjectSetup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewScope$Type extends MessageType<AccessReviewScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewScope", [
            { no: 1, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewScope
 */
export const AccessReviewScope = new AccessReviewScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewExclusionScope$Type extends MessageType<AccessReviewExclusionScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewExclusionScope", [
            { no: 1, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewExclusionScope
 */
export const AccessReviewExclusionScope = new AccessReviewExclusionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncludedUserAttributeValue$Type extends MessageType<IncludedUserAttributeValue> {
    constructor() {
        super("c1.api.accessreview.v1.IncludedUserAttributeValue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.IncludedUserAttributeValue
 */
export const IncludedUserAttributeValue = new IncludedUserAttributeValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncludedUserAttributeValues$Type extends MessageType<IncludedUserAttributeValues> {
    constructor() {
        super("c1.api.accessreview.v1.IncludedUserAttributeValues", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IncludedUserAttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.IncludedUserAttributeValues
 */
export const IncludedUserAttributeValues = new IncludedUserAttributeValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewInclusionScope$Type extends MessageType<AccessReviewInclusionScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewInclusionScope", [
            { no: 1, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 3, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 4, name: "multi_user_profile_attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => IncludedUserAttributeValues }, options: { "validate.rules": { map: { keys: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "20", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "manager_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "no_account_owners", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewInclusionScope
 */
export const AccessReviewInclusionScope = new AccessReviewInclusionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewExpandMask$Type extends MessageType<AccessReviewExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "created_by_user_id", "policy_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewExpandMask
 */
export const AccessReviewExpandMask = new AccessReviewExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppEntitlementExpandMask$Type extends MessageType<AccessReviewAppEntitlementExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "policy_id", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask
 */
export const AccessReviewAppEntitlementExpandMask = new AccessReviewAppEntitlementExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateAppEntitlementExpandMask$Type extends MessageType<AccessReviewTemplateAppEntitlementExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "policy_id", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask
 */
export const AccessReviewTemplateAppEntitlementExpandMask = new AccessReviewTemplateAppEntitlementExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewView$Type extends MessageType<AccessReviewView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewView", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReview },
            { no: 2, name: "created_by_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "object_permissions", kind: "message", T: () => ActorObjectPermissions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewView
 */
export const AccessReviewView = new AccessReviewView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListEntitlementsWithMultiAppRequest$Type extends MessageType<AccessReviewServiceListEntitlementsWithMultiAppRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewAppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppRequest
 */
export const AccessReviewServiceListEntitlementsWithMultiAppRequest = new AccessReviewServiceListEntitlementsWithMultiAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppEntitlementView$Type extends MessageType<AccessReviewAppEntitlementView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppEntitlementView", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementView
 */
export const AccessReviewAppEntitlementView = new AccessReviewAppEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListEntitlementsWithMultiAppResponse$Type extends MessageType<AccessReviewServiceListEntitlementsWithMultiAppResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppResponse
 */
export const AccessReviewServiceListEntitlementsWithMultiAppResponse = new AccessReviewServiceListEntitlementsWithMultiAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceGetResponse$Type extends MessageType<AccessReviewServiceGetResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceGetResponse", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceGetResponse
 */
export const AccessReviewServiceGetResponse = new AccessReviewServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceCreateResponse$Type extends MessageType<AccessReviewServiceCreateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceCreateResponse", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateResponse
 */
export const AccessReviewServiceCreateResponse = new AccessReviewServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceUpdateResponse$Type extends MessageType<AccessReviewServiceUpdateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceUpdateResponse", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateResponse
 */
export const AccessReviewServiceUpdateResponse = new AccessReviewServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessReviewSelectionRequest$Type extends MessageType<GetAccessReviewSelectionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetAccessReviewSelectionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "selection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetAccessReviewSelectionRequest
 */
export const GetAccessReviewSelectionRequest = new GetAccessReviewSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionExpandMask$Type extends MessageType<AccessReviewSelectionExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "user_id", "entitlement_ids", "certify_task_id", "app_id", "policy_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionExpandMask
 */
export const AccessReviewSelectionExpandMask = new AccessReviewSelectionExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlement$Type extends MessageType<AccessReviewEntitlement> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlement", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlement
 */
export const AccessReviewEntitlement = new AccessReviewEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementView$Type extends MessageType<AccessReviewEntitlementView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementView", [
            { no: 1, name: "access_review_entitlement", kind: "message", T: () => AccessReviewEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementView
 */
export const AccessReviewEntitlementView = new AccessReviewEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionRef$Type extends MessageType<AccessReviewSelectionRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionRef
 */
export const AccessReviewSelectionRef = new AccessReviewSelectionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceRef$Type extends MessageType<AccessReviewConnectorSourceRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceRef", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceRef
 */
export const AccessReviewConnectorSourceRef = new AccessReviewConnectorSourceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelection$Type extends MessageType<AccessReviewSelection> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelection", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "revoke_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewSelectionState", AccessReviewSelectionState, "ACCESS_REVIEW_SELECTION_STATE_"] },
            { no: 10, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelection
 */
export const AccessReviewSelection = new AccessReviewSelection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionView$Type extends MessageType<AccessReviewSelectionView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionView", [
            { no: 1, name: "access_review_selection", kind: "message", T: () => AccessReviewSelection },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "entitlements_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "cert_task_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionView
 */
export const AccessReviewSelectionView = new AccessReviewSelectionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceGetRequest$Type extends MessageType<AccessReviewServiceGetRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceGetRequest
 */
export const AccessReviewServiceGetRequest = new AccessReviewServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceUpdateRequest$Type extends MessageType<AccessReviewServiceUpdateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceUpdateRequest", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReview, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateRequest
 */
export const AccessReviewServiceUpdateRequest = new AccessReviewServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceCreateRequest$Type extends MessageType<AccessReviewServiceCreateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "completion_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask },
            { no: 7, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 8, name: "duplicate_from", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 9, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateRequest
 */
export const AccessReviewServiceCreateRequest = new AccessReviewServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceDeleteRequest$Type extends MessageType<AccessReviewServiceDeleteRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteRequest
 */
export const AccessReviewServiceDeleteRequest = new AccessReviewServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceDeleteResponse$Type extends MessageType<AccessReviewServiceDeleteResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteResponse
 */
export const AccessReviewServiceDeleteResponse = new AccessReviewServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListRequest$Type extends MessageType<AccessReviewServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListRequest
 */
export const AccessReviewServiceListRequest = new AccessReviewServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListResponse$Type extends MessageType<AccessReviewServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListResponse
 */
export const AccessReviewServiceListResponse = new AccessReviewServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReportRef$Type extends MessageType<AccessReviewReportRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReportRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReportRef
 */
export const AccessReviewReportRef = new AccessReviewReportRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReport$Type extends MessageType<AccessReviewReport> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReport", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.ReportState", ReportState, "REPORT_STATE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "hashes", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReport
 */
export const AccessReviewReport = new AccessReviewReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReportServiceListRequest$Type extends MessageType<AccessReviewReportServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReportServiceListRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewReportRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListRequest
 */
export const AccessReviewReportServiceListRequest = new AccessReviewReportServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReportServiceListResponse$Type extends MessageType<AccessReviewReportServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReportServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewReport },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListResponse
 */
export const AccessReviewReportServiceListResponse = new AccessReviewReportServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceServiceListOutdatedRequest$Type extends MessageType<AccessReviewConnectorSourceServiceListOutdatedRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedRequest
 */
export const AccessReviewConnectorSourceServiceListOutdatedRequest = new AccessReviewConnectorSourceServiceListOutdatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceServiceListOutdatedResponse$Type extends MessageType<AccessReviewConnectorSourceServiceListOutdatedResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedResponse
 */
export const AccessReviewConnectorSourceServiceListOutdatedResponse = new AccessReviewConnectorSourceServiceListOutdatedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollupByApp$Type extends MessageType<AccessReviewEntitlementRollupByApp> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollup }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp
 */
export const AccessReviewEntitlementRollupByApp = new AccessReviewEntitlementRollupByApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollupByAppUser$Type extends MessageType<AccessReviewEntitlementRollupByAppUser> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollupByAppUser", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollup }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByAppUser
 */
export const AccessReviewEntitlementRollupByAppUser = new AccessReviewEntitlementRollupByAppUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollup$Type extends MessageType<AccessReviewEntitlementRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollup", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "assigned_tasks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "pending_submission_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollup
 */
export const AccessReviewEntitlementRollup = new AccessReviewEntitlementRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollupExpandMask$Type extends MessageType<AccessReviewEntitlementRollupExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_resource_type_id", "app_resource_id", "app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask
 */
export const AccessReviewEntitlementRollupExpandMask = new AccessReviewEntitlementRollupExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewExpandMask$Type extends MessageType<AccessReviewEntitlementPreviewExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "app_id", "app_entitlement_id", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask
 */
export const AccessReviewEntitlementPreviewExpandMask = new AccessReviewEntitlementPreviewExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewServiceSearchRequest$Type extends MessageType<AccessReviewEntitlementPreviewServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => AccessReviewEntitlementPreviewExpandMask },
            { no: 8, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchRequest
 */
export const AccessReviewEntitlementPreviewServiceSearchRequest = new AccessReviewEntitlementPreviewServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreview$Type extends MessageType<AccessReviewEntitlementPreview> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreview", [
            { no: 1, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "entitlement_expiration_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "entitlement_discovered_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreview
 */
export const AccessReviewEntitlementPreview = new AccessReviewEntitlementPreview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewView$Type extends MessageType<AccessReviewEntitlementPreviewView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewView", [
            { no: 1, name: "scope", kind: "message", T: () => AccessReviewEntitlementPreview },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_entitlement_user_binding", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewView
 */
export const AccessReviewEntitlementPreviewView = new AccessReviewEntitlementPreviewView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewServiceSearchResponse$Type extends MessageType<AccessReviewEntitlementPreviewServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementPreviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchResponse
 */
export const AccessReviewEntitlementPreviewServiceSearchResponse = new AccessReviewEntitlementPreviewServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewRef$Type extends MessageType<AccessReviewRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewRef
 */
export const AccessReviewRef = new AccessReviewRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplate$Type extends MessageType<AccessReviewTemplate> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplate", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "access_review_duration", kind: "message", T: () => Duration },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 9, name: "inclusion_scope", kind: "message", T: () => AccessReviewInclusionScope },
            { no: 10, name: "recurrence_rule", kind: "message", T: () => RecurrenceRule },
            { no: 11, name: "next_scheduled_campaign_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{}] } } },
            { no: 12, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 13, name: "is_campaign_schedule_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "slack_channel", kind: "message", oneof: "slackChannelDetails", T: () => SlackChannel },
            { no: 14, name: "occurrences", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "scope", kind: "message", T: () => AccessReviewScopeV2 },
            { no: 16, name: "review_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 17, name: "use_policy_override", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "default_view", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewViewType", AccessReviewViewType, "ACCESS_REVIEW_VIEW_TYPE_"] },
            { no: 19, name: "auto_generate_report", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] },
            { no: 21, name: "exempt_certified_access_conflicts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "signature_config", kind: "message", T: () => ReviewSignatureConfig },
            { no: 23, name: "auto_start_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "accuracy_issue_action", kind: "enum", T: () => ["c1.api.accessreview.v1.AccuracyIssueAction", AccuracyIssueAction, "ACCURACY_ISSUE_ACTION_"] },
            { no: 25, name: "auto_close_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "auto_close_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.CloseDecision", CloseDecision, "CLOSE_DECISION_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access Review Template" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplate
 */
export const AccessReviewTemplate = new AccessReviewTemplate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecurrenceRule$Type extends MessageType<RecurrenceRule> {
    constructor() {
        super("c1.api.accessreview.v1.RecurrenceRule", [
            { no: 1, name: "frequency", kind: "enum", T: () => ["c1.api.accessreview.v1.RecurrenceRule.Frequency", RecurrenceRule_Frequency, "FREQUENCY_"] },
            { no: 2, name: "interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "end_date", kind: "message", oneof: "endCondition", T: () => Timestamp },
            { no: 5, name: "occurrences", kind: "scalar", oneof: "endCondition", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.RecurrenceRule
 */
export const RecurrenceRule = new RecurrenceRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateRequest$Type extends MessageType<AccessReviewTemplateServiceCreateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "access_review_duration", kind: "message", T: () => Duration },
            { no: 4, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 7, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateRequest
 */
export const AccessReviewTemplateServiceCreateRequest = new AccessReviewTemplateServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateResponse$Type extends MessageType<AccessReviewTemplateServiceCreateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateResponse", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateResponse
 */
export const AccessReviewTemplateServiceCreateResponse = new AccessReviewTemplateServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceDeleteRequest$Type extends MessageType<AccessReviewTemplateServiceDeleteRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteRequest
 */
export const AccessReviewTemplateServiceDeleteRequest = new AccessReviewTemplateServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceDeleteResponse$Type extends MessageType<AccessReviewTemplateServiceDeleteResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteResponse
 */
export const AccessReviewTemplateServiceDeleteResponse = new AccessReviewTemplateServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListRequest$Type extends MessageType<AccessReviewTemplateServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListRequest
 */
export const AccessReviewTemplateServiceListRequest = new AccessReviewTemplateServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListResponse$Type extends MessageType<AccessReviewTemplateServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplate },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListResponse
 */
export const AccessReviewTemplateServiceListResponse = new AccessReviewTemplateServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchRequest$Type extends MessageType<AccessReviewTemplateServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "sort_options", kind: "message", T: () => SortOptions },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateRef },
            { no: 6, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchRequest
 */
export const AccessReviewTemplateServiceSearchRequest = new AccessReviewTemplateServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchResponse$Type extends MessageType<AccessReviewTemplateServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplate },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchResponse
 */
export const AccessReviewTemplateServiceSearchResponse = new AccessReviewTemplateServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceGetRequest$Type extends MessageType<AccessReviewTemplateServiceGetRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetRequest
 */
export const AccessReviewTemplateServiceGetRequest = new AccessReviewTemplateServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceGetResponse$Type extends MessageType<AccessReviewTemplateServiceGetResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceGetResponse", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetResponse
 */
export const AccessReviewTemplateServiceGetResponse = new AccessReviewTemplateServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListOwnersRequest$Type extends MessageType<AccessReviewTemplateServiceListOwnersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersRequest
 */
export const AccessReviewTemplateServiceListOwnersRequest = new AccessReviewTemplateServiceListOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListOwnersResponse$Type extends MessageType<AccessReviewTemplateServiceListOwnersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersResponse
 */
export const AccessReviewTemplateServiceListOwnersResponse = new AccessReviewTemplateServiceListOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchOwnersRequest$Type extends MessageType<AccessReviewTemplateServiceSearchOwnersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateOwnerRef },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersRequest
 */
export const AccessReviewTemplateServiceSearchOwnersRequest = new AccessReviewTemplateServiceSearchOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchOwnerView$Type extends MessageType<AccessReviewTemplateServiceSearchOwnerView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView
 */
export const AccessReviewTemplateServiceSearchOwnerView = new AccessReviewTemplateServiceSearchOwnerView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchOwnersResponse$Type extends MessageType<AccessReviewTemplateServiceSearchOwnersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateServiceSearchOwnerView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersResponse
 */
export const AccessReviewTemplateServiceSearchOwnersResponse = new AccessReviewTemplateServiceSearchOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceUpdateRequest$Type extends MessageType<AccessReviewTemplateServiceUpdateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateRequest", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateRequest
 */
export const AccessReviewTemplateServiceUpdateRequest = new AccessReviewTemplateServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceUpdateResponse$Type extends MessageType<AccessReviewTemplateServiceUpdateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateResponse", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateResponse
 */
export const AccessReviewTemplateServiceUpdateResponse = new AccessReviewTemplateServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSetOwnersRequest$Type extends MessageType<AccessReviewTemplateServiceSetOwnersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersRequest
 */
export const AccessReviewTemplateServiceSetOwnersRequest = new AccessReviewTemplateServiceSetOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSetOwnersResponse$Type extends MessageType<AccessReviewTemplateServiceSetOwnersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersResponse
 */
export const AccessReviewTemplateServiceSetOwnersResponse = new AccessReviewTemplateServiceSetOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListAccessReviewsRequest$Type extends MessageType<AccessReviewTemplateServiceListAccessReviewsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: false } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsRequest
 */
export const AccessReviewTemplateServiceListAccessReviewsRequest = new AccessReviewTemplateServiceListAccessReviewsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListAccessReviewsResponse$Type extends MessageType<AccessReviewTemplateServiceListAccessReviewsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsResponse
 */
export const AccessReviewTemplateServiceListAccessReviewsResponse = new AccessReviewTemplateServiceListAccessReviewsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateRef$Type extends MessageType<AccessReviewTemplateRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateRef
 */
export const AccessReviewTemplateRef = new AccessReviewTemplateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateOwnerRef$Type extends MessageType<AccessReviewTemplateOwnerRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateOwnerRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateOwnerRef
 */
export const AccessReviewTemplateOwnerRef = new AccessReviewTemplateOwnerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest$Type extends MessageType<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest
 */
export const AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest = new AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse$Type extends MessageType<AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse
 */
export const AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse = new AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateAppResourceRollupItem$Type extends MessageType<AccessReviewTemplateAppResourceRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResource },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateAppEntitlementView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem
 */
export const AccessReviewTemplateAppResourceRollupItem = new AccessReviewTemplateAppResourceRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateAppEntitlementView$Type extends MessageType<AccessReviewTemplateAppEntitlementView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView
 */
export const AccessReviewTemplateAppEntitlementView = new AccessReviewTemplateAppEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewScopeV2$Type extends MessageType<AccessReviewScopeV2> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewScopeV2", [
            { no: 100, name: "app_access", kind: "message", oneof: "appsAndResourcesScope", T: () => ApplicationAccessScope },
            { no: 101, name: "specific_resources", kind: "message", oneof: "appsAndResourcesScope", T: () => SpecificResourcesScope },
            { no: 102, name: "app_selection_criteria", kind: "message", oneof: "appsAndResourcesScope", T: () => AppSelectionCriteriaScope },
            { no: 103, name: "resource_type_selections", kind: "message", oneof: "appsAndResourcesScope", T: () => ResourceTypeSelectionScope },
            { no: 200, name: "all_users", kind: "message", oneof: "usersScope", T: () => AllUsersScope },
            { no: 201, name: "selected_users", kind: "message", oneof: "usersScope", T: () => SelectedUsersScope },
            { no: 202, name: "user_criteria", kind: "message", oneof: "usersScope", T: () => UserCriteriaScope },
            { no: 203, name: "cel_expression", kind: "message", oneof: "usersScope", T: () => CelExpressionScope },
            { no: 300, name: "all_accounts", kind: "message", oneof: "accountsScope", T: () => AllAccountsScope },
            { no: 301, name: "account_criteria", kind: "message", oneof: "accountsScope", T: () => AccountCriteriaScope },
            { no: 302, name: "account_cel_expression", kind: "message", oneof: "accountsScope", T: () => CelExpressionScope },
            { no: 400, name: "all_grants", kind: "message", oneof: "grantsScope", T: () => AllGrantsScope },
            { no: 401, name: "grants_by_criteria", kind: "message", oneof: "grantsScope", T: () => GrantsByCriteriaScope },
            { no: 500, name: "all_access_conflicts", kind: "message", oneof: "accessConflictsScope", T: () => AllAccessConflictsScope },
            { no: 501, name: "specific_access_conflicts", kind: "message", oneof: "accessConflictsScope", T: () => SpecificAccessConflictsScope }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewScopeV2
 */
export const AccessReviewScopeV2 = new AccessReviewScopeV2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllAccessConflictsScope$Type extends MessageType<AllAccessConflictsScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllAccessConflictsScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllAccessConflictsScope
 */
export const AllAccessConflictsScope = new AllAccessConflictsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpecificAccessConflictsScope$Type extends MessageType<SpecificAccessConflictsScope> {
    constructor() {
        super("c1.api.accessreview.v1.SpecificAccessConflictsScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SpecificAccessConflictsScope
 */
export const SpecificAccessConflictsScope = new SpecificAccessConflictsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplicationAccessScope$Type extends MessageType<ApplicationAccessScope> {
    constructor() {
        super("c1.api.accessreview.v1.ApplicationAccessScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ApplicationAccessScope
 */
export const ApplicationAccessScope = new ApplicationAccessScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpecificResourcesScope$Type extends MessageType<SpecificResourcesScope> {
    constructor() {
        super("c1.api.accessreview.v1.SpecificResourcesScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SpecificResourcesScope
 */
export const SpecificResourcesScope = new SpecificResourcesScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSelectionCriteriaScope$Type extends MessageType<AppSelectionCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.AppSelectionCriteriaScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppSelectionCriteriaScope
 */
export const AppSelectionCriteriaScope = new AppSelectionCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeSelectionScope$Type extends MessageType<ResourceTypeSelectionScope> {
    constructor() {
        super("c1.api.accessreview.v1.ResourceTypeSelectionScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ResourceTypeSelectionScope
 */
export const ResourceTypeSelectionScope = new ResourceTypeSelectionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllUsersScope$Type extends MessageType<AllUsersScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllUsersScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllUsersScope
 */
export const AllUsersScope = new AllUsersScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectedUsersScope$Type extends MessageType<SelectedUsersScope> {
    constructor() {
        super("c1.api.accessreview.v1.SelectedUsersScope", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SelectedUsersScope
 */
export const SelectedUsersScope = new SelectedUsersScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserCriteriaScope$Type extends MessageType<UserCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.UserCriteriaScope", [
            { no: 1, name: "manager_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "user_status", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus$] },
            { no: 3, name: "multi_user_profile_attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => IncludedUserAttributeValues }, options: { "validate.rules": { map: { keys: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } },
            { no: 4, name: "group_app_entitlements_ref", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { maxItems: "10" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UserCriteriaScope
 */
export const UserCriteriaScope = new UserCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CelExpressionScope$Type extends MessageType<CelExpressionScope> {
    constructor() {
        super("c1.api.accessreview.v1.CelExpressionScope", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.CelExpressionScope
 */
export const CelExpressionScope = new CelExpressionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllAccountsScope$Type extends MessageType<AllAccountsScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllAccountsScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllAccountsScope
 */
export const AllAccountsScope = new AllAccountsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountCriteriaScope$Type extends MessageType<AccountCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccountCriteriaScope", [
            { no: 1, name: "no_account_owner", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"] },
            { no: 3, name: "account_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] },
            { no: 4, name: "account_domain", kind: "enum", T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccountCriteriaScope
 */
export const AccountCriteriaScope = new AccountCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllGrantsScope$Type extends MessageType<AllGrantsScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllGrantsScope", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllGrantsScope
 */
export const AllGrantsScope = new AllGrantsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantsByCriteriaScope$Type extends MessageType<GrantsByCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.GrantsByCriteriaScope", [
            { no: 100, name: "days_since_added", kind: "message", oneof: "criteriaFilter", T: () => Duration },
            { no: 101, name: "days_since_reviewed", kind: "message", oneof: "criteriaFilter", T: () => Duration },
            { no: 103, name: "grants_added_between", kind: "message", oneof: "criteriaFilter", T: () => GrantsAddedBetween },
            { no: 1, name: "type_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.GrantFilterType", GrantFilterType, "GRANT_FILTER_TYPE_"] },
            { no: 2, name: "days_since_last_used", kind: "message", T: () => Duration },
            { no: 3, name: "source_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.GrantSourceFilter", GrantSourceFilter, "GRANT_SOURCE_FILTER_"] },
            { no: 4, name: "access_profile_filter", kind: "message", T: () => GrantAccessProfileFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GrantsByCriteriaScope
 */
export const GrantsByCriteriaScope = new GrantsByCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantsAddedBetween$Type extends MessageType<GrantsAddedBetween> {
    constructor() {
        super("c1.api.accessreview.v1.GrantsAddedBetween", [
            { no: 1, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_date", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GrantsAddedBetween
 */
export const GrantsAddedBetween = new GrantsAddedBetween$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantAccessProfileFilter$Type extends MessageType<GrantAccessProfileFilter> {
    constructor() {
        super("c1.api.accessreview.v1.GrantAccessProfileFilter", [
            { no: 1, name: "filter_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessProfileFilterType", AccessProfileFilterType, "ACCESS_PROFILE_FILTER_TYPE_"] },
            { no: 2, name: "excluded_access_profile_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "included_access_profile_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GrantAccessProfileFilter
 */
export const GrantAccessProfileFilter = new GrantAccessProfileFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSource$Type extends MessageType<AccessReviewConnectorSource> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSource", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "sync_start_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "sync_end_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "connector_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 11, name: "connector_type", kind: "enum", T: () => ["c1.api.accessreview.v1.ConnectorType", ConnectorType, "CONNECTOR_TYPE_"] },
            { no: 12, name: "connector_sync_artifact", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "stats", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ } },
            { no: 14, name: "frozen_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSource
 */
export const AccessReviewConnectorSource = new AccessReviewConnectorSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceView$Type extends MessageType<AccessReviewConnectorSourceView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceView", [
            { no: 1, name: "access_review_connector_source", kind: "message", T: () => AccessReviewConnectorSource },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sync_lifecycle_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceView
 */
export const AccessReviewConnectorSourceView = new AccessReviewConnectorSourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceExpandMask$Type extends MessageType<AccessReviewConnectorSourceExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "connector_id", "sync_lifecycle_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask
 */
export const AccessReviewConnectorSourceExpandMask = new AccessReviewConnectorSourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceRollupRef$Type extends MessageType<AccessReviewTemplateResourceRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef
 */
export const AccessReviewTemplateResourceRollupRef = new AccessReviewTemplateResourceRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceRollupSearchRequest$Type extends MessageType<AccessReviewTemplateResourceRollupSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewTemplateAppEntitlementExpandMask },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateResourceRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchRequest
 */
export const AccessReviewTemplateResourceRollupSearchRequest = new AccessReviewTemplateResourceRollupSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceRollupSearchResponse$Type extends MessageType<AccessReviewTemplateResourceRollupSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateAppResourceRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchResponse
 */
export const AccessReviewTemplateResourceRollupSearchResponse = new AccessReviewTemplateResourceRollupSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceTypeRollupItem$Type extends MessageType<AccessReviewTemplateResourceTypeRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceTypeView },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem
 */
export const AccessReviewTemplateResourceTypeRollupItem = new AccessReviewTemplateResourceTypeRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceTypeRollupRef$Type extends MessageType<AccessReviewTemplateResourceTypeRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef
 */
export const AccessReviewTemplateResourceTypeRollupRef = new AccessReviewTemplateResourceTypeRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSearchResourceTypeRollupSearchRequest$Type extends MessageType<AccessReviewTemplateSearchResourceTypeRollupSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateResourceTypeRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "200" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchRequest
 */
export const AccessReviewTemplateSearchResourceTypeRollupSearchRequest = new AccessReviewTemplateSearchResourceTypeRollupSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSearchResourceTypeRollupSearchResponse$Type extends MessageType<AccessReviewTemplateSearchResourceTypeRollupSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateResourceTypeRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchResponse
 */
export const AccessReviewTemplateSearchResourceTypeRollupSearchResponse = new AccessReviewTemplateSearchResourceTypeRollupSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateScopeRequest$Type extends MessageType<ValidateScopeRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ValidateScopeRequest", [
            { no: 1, name: "campaign_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "campaign_type", kind: "enum", T: () => ["c1.api.accessreview.v1.ValidateScopeRequest.CampaignType", ValidateScopeRequest_CampaignType, "CAMPAIGN_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ValidateScopeRequest
 */
export const ValidateScopeRequest = new ValidateScopeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceListRequest$Type extends MessageType<AccessReviewConnectorSourceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListRequest
 */
export const AccessReviewConnectorSourceListRequest = new AccessReviewConnectorSourceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceListResponse$Type extends MessageType<AccessReviewConnectorSourceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListResponse
 */
export const AccessReviewConnectorSourceListResponse = new AccessReviewConnectorSourceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceSearchRequest$Type extends MessageType<AccessReviewConnectorSourceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchRequest
 */
export const AccessReviewConnectorSourceSearchRequest = new AccessReviewConnectorSourceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceSearchResponse$Type extends MessageType<AccessReviewConnectorSourceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchResponse
 */
export const AccessReviewConnectorSourceSearchResponse = new AccessReviewConnectorSourceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceOutdatedSearchRequest$Type extends MessageType<AccessReviewConnectorSourceOutdatedSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchRequest
 */
export const AccessReviewConnectorSourceOutdatedSearchRequest = new AccessReviewConnectorSourceOutdatedSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceOutdatedSearchResponse$Type extends MessageType<AccessReviewConnectorSourceOutdatedSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchResponse
 */
export const AccessReviewConnectorSourceOutdatedSearchResponse = new AccessReviewConnectorSourceOutdatedSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetupAccessConflictExpandMask$Type extends MessageType<AccessReviewSetupAccessConflictExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "access_conflict_monitor_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask
 */
export const AccessReviewSetupAccessConflictExpandMask = new AccessReviewSetupAccessConflictExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetupAccessConflictView$Type extends MessageType<AccessReviewSetupAccessConflictView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetupAccessConflictView", [
            { no: 1, name: "access_conflict", kind: "message", T: () => AccessReviewSetupAccessConflict },
            { no: 2, name: "access_conflict_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictView
 */
export const AccessReviewSetupAccessConflictView = new AccessReviewSetupAccessConflictView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetupAccessConflict$Type extends MessageType<AccessReviewSetupAccessConflict> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetupAccessConflict", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflict
 */
export const AccessReviewSetupAccessConflict = new AccessReviewSetupAccessConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewByAccessConflictsServiceListRequest$Type extends MessageType<AccessReviewByAccessConflictsServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewSetupAccessConflictExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListRequest
 */
export const AccessReviewByAccessConflictsServiceListRequest = new AccessReviewByAccessConflictsServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewByAccessConflictsServiceListResponse$Type extends MessageType<AccessReviewByAccessConflictsServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSetupAccessConflictView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListResponse
 */
export const AccessReviewByAccessConflictsServiceListResponse = new AccessReviewByAccessConflictsServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetScopeByAccessConflictRequest$Type extends MessageType<AccessReviewSetScopeByAccessConflictRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_conflict_monitor_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictRequest
 */
export const AccessReviewSetScopeByAccessConflictRequest = new AccessReviewSetScopeByAccessConflictRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetScopeByAccessConflictResponse$Type extends MessageType<AccessReviewSetScopeByAccessConflictResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictResponse
 */
export const AccessReviewSetScopeByAccessConflictResponse = new AccessReviewSetScopeByAccessConflictResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetupAccessConflictView$Type extends MessageType<AccessReviewTemplateSetupAccessConflictView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView", [
            { no: 1, name: "access_conflict", kind: "message", T: () => AccessReviewTemplateSetupAccessConflict },
            { no: 2, name: "access_conflict_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView
 */
export const AccessReviewTemplateSetupAccessConflictView = new AccessReviewTemplateSetupAccessConflictView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetupAccessConflict$Type extends MessageType<AccessReviewTemplateSetupAccessConflict> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict
 */
export const AccessReviewTemplateSetupAccessConflict = new AccessReviewTemplateSetupAccessConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateByAccessConflictsServiceListRequest$Type extends MessageType<AccessReviewTemplateByAccessConflictsServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewSetupAccessConflictExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListRequest
 */
export const AccessReviewTemplateByAccessConflictsServiceListRequest = new AccessReviewTemplateByAccessConflictsServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateByAccessConflictsServiceListResponse$Type extends MessageType<AccessReviewTemplateByAccessConflictsServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateSetupAccessConflictView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListResponse
 */
export const AccessReviewTemplateByAccessConflictsServiceListResponse = new AccessReviewTemplateByAccessConflictsServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetScopeByAccessConflictRequest$Type extends MessageType<AccessReviewTemplateSetScopeByAccessConflictRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_conflict_monitor_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictRequest
 */
export const AccessReviewTemplateSetScopeByAccessConflictRequest = new AccessReviewTemplateSetScopeByAccessConflictRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetScopeByAccessConflictResponse$Type extends MessageType<AccessReviewTemplateSetScopeByAccessConflictResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictResponse
 */
export const AccessReviewTemplateSetScopeByAccessConflictResponse = new AccessReviewTemplateSetScopeByAccessConflictResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewService
 */
export const AccessReviewService = new ServiceType("c1.api.accessreview.v1.AccessReviewService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/access_review/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceGetRequest, O: AccessReviewServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceCreateRequest, O: AccessReviewServiceCreateResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review/{access_review.id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceUpdateRequest, O: AccessReviewServiceUpdateResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/access_reviews", query: { page_size: "page_size", page_token: "page_token" }, stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access Reviews" }], group: "Access Review" }] } }, I: AccessReviewServiceListRequest, O: AccessReviewServiceListResponse },
    { name: "ListEntitlementsWithMultiApp", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewServiceListEntitlementsWithMultiAppRequest, O: AccessReviewServiceListEntitlementsWithMultiAppResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/access_review/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceDeleteRequest, O: AccessReviewServiceDeleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewReportService
 */
export const AccessReviewReportService = new ServiceType("c1.api.accessreview.v1.AccessReviewReportService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewReportServiceListRequest, O: AccessReviewReportServiceListResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewEntitlementPreviewService
 */
export const AccessReviewEntitlementPreviewService = new ServiceType("c1.api.accessreview.v1.AccessReviewEntitlementPreviewService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewEntitlementPreviewServiceSearchRequest, O: AccessReviewEntitlementPreviewServiceSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewTemplateService
 */
export const AccessReviewTemplateService = new ServiceType("c1.api.accessreview.v1.AccessReviewTemplateService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review_template", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceCreateRequest, O: AccessReviewTemplateServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/access_review_template/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceDeleteRequest, O: AccessReviewTemplateServiceDeleteResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceListRequest, O: AccessReviewTemplateServiceListResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceSearchRequest, O: AccessReviewTemplateServiceSearchResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/access_review_template/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceGetRequest, O: AccessReviewTemplateServiceGetResponse },
    { name: "ListOwners", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceListOwnersRequest, O: AccessReviewTemplateServiceListOwnersResponse },
    { name: "SetOwners", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewTemplateServiceSetOwnersRequest, O: AccessReviewTemplateServiceSetOwnersResponse },
    { name: "SearchOwners", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceSearchOwnersRequest, O: AccessReviewTemplateServiceSearchOwnersResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review_template/{access_review_template.id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceUpdateRequest, O: AccessReviewTemplateServiceUpdateResponse },
    { name: "ListAccessReviews", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceListAccessReviewsRequest, O: AccessReviewTemplateServiceListAccessReviewsResponse },
    { name: "CreateAccessReviewFromTemplate", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, O: AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse },
    { name: "SearchTemplateResourceRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateResourceRollupSearchRequest, O: AccessReviewTemplateResourceRollupSearchResponse },
    { name: "SearchTemplateResourceTypeRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateSearchResourceTypeRollupSearchRequest, O: AccessReviewTemplateSearchResourceTypeRollupSearchResponse },
    { name: "ListAccessConflicts", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateByAccessConflictsServiceListRequest, O: AccessReviewTemplateByAccessConflictsServiceListResponse },
    { name: "SetTemplateCampaignScopeByAccessConflict", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewTemplateSetScopeByAccessConflictRequest, O: AccessReviewTemplateSetScopeByAccessConflictResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewConnectorSourceService
 */
export const AccessReviewConnectorSourceService = new ServiceType("c1.api.accessreview.v1.AccessReviewConnectorSourceService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceListRequest, O: AccessReviewConnectorSourceListResponse },
    { name: "ListAllOutdatedConnectorSources", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceServiceListOutdatedRequest, O: AccessReviewConnectorSourceServiceListOutdatedResponse },
    { name: "SearchAccessReviewConnectorSources", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceSearchRequest, O: AccessReviewConnectorSourceSearchResponse },
    { name: "SearchOutdatedAccessReviewConnectorSources", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceOutdatedSearchRequest, O: AccessReviewConnectorSourceOutdatedSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewByAccessConflictsService
 */
export const AccessReviewByAccessConflictsService = new ServiceType("c1.api.accessreview.v1.AccessReviewByAccessConflictsService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewByAccessConflictsServiceListRequest, O: AccessReviewByAccessConflictsServiceListResponse },
    { name: "SetCampaignScopeByAccessConflict", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewSetScopeByAccessConflictRequest, O: AccessReviewSetScopeByAccessConflictResponse }
]);
